import { render, staticRenderFns } from "./RequiredBooksBlock.vue?vue&type=template&id=c568cccc&scoped=true"
import script from "./RequiredBooksBlock.vue?vue&type=script&lang=js"
export * from "./RequiredBooksBlock.vue?vue&type=script&lang=js"
import style0 from "./RequiredBooksBlock.vue?vue&type=style&index=0&id=c568cccc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../checkout/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c568cccc",
  null
  
)

export default component.exports